__turbopack_context__.v({
  "container": "mdu0Jq_container",
  "isAllInClipboard": "mdu0Jq_isAllInClipboard",
});
